(() => {
  // Guard — only initialize once across all product cards
  if (window.AshCardProductInitialized) return;
  window.AshCardProductInitialized = true;

  const overlay = document.getElementById('AshGridMbOverlay');

  function openSizePanel(btn) {
    const id = btn.dataset.id;
    const wrapper = document.querySelector(`.ash-grid-mb-size-wrp[data-id="${id}"]`);
    if (!wrapper) return;

    closeAll();
    wrapper.classList.add('is-open');
    overlay?.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
  }

  function closeAll() {
    document.querySelectorAll('.ash-grid-mb-size-wrp.is-open').forEach(el => {
      el.classList.remove('is-open');
    });
    overlay?.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
  }

  overlay?.addEventListener('click', closeAll);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

  // Single global click handler for everything
  document.addEventListener('click', (e) => {
    // Desktop size button
    const desktopBtn = e.target.closest('.ash-grid-item-size');
    if (desktopBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (!desktopBtn.classList.contains('ash-product-unavailable')) {
        const variantId = desktopBtn.dataset.variantId;
        if (variantId) window.AshCart.emit('cart:add', { variantId, quantity: 1 });
      }
      return;
    }

    // Mobile open button
    const openBtn = e.target.closest('.ash-grid-mb-size-btn');
    if (openBtn) {
      e.preventDefault();
      e.stopPropagation();
      openSizePanel(openBtn);
      return;
    }

    // Mobile close button
    const closeBtn = e.target.closest('.ash-grid-mb-size-close');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      closeAll();
      return;
    }

    const bagBtn = e.target.closest('.ash-ss-bag');
    if (bagBtn) {
      const isAvailable = bagBtn.dataset.available === 'true';
      const variantId = bagBtn.dataset.variantId;

      if (!isAvailable || !variantId) return;

      window.AshCart?.emit('cart:add', {
        variantId,
        quantity: 1,
      });
    }

    // Mobile radio label — stop <a> but let radio check
    const label = e.target.closest('.ash-grid-item-mb-size');
    if (label) {
      e.stopPropagation();
      return;
    }

    // Mobile Add to Cart
    const actionBtn = e.target.closest('.ash-grid-item-mb-action');
    if (actionBtn) {
      e.preventDefault();
      e.stopPropagation();

      const wrapper = actionBtn.closest('.ash-grid-mb-size-wrp');
      const selectedInput = wrapper?.querySelector('.ash-grid-item-mb-size-input:checked');

      if (!selectedInput) {
        const grid = wrapper?.querySelector('.ash-grid-item-mb-sizes');
        grid?.classList.add('ash-shake');
        setTimeout(() => grid?.classList.remove('ash-shake'), 500);
        return;
      }

      const variantId = selectedInput.dataset.variantId;
      if (variantId) {
        window.AshCart.emit('cart:add', { variantId, quantity: 1 });
        closeAll();
      }
      return;
    }
  });

})();
